import { SystemLabel } from './system-label';

export class RestockSystemLabel extends SystemLabel {
  getSortOrderTitle(): string {
    return 'Restocked';
  }
}
